<!--  -->
<template>
  <div class="car-item">
    <div class="shop-select-area">
      <div class="take-type-title-content fl-align-center">
        <el-checkbox
          v-model="info.checked"
          :true-label="1"
          :false-label="0"
          @change="(val) => changeShopSelectAll(val, info.entityId)"
        >
          <div class="take-type-title">
            <span>{{ info.entityName }} {{ info.entityEnName }}</span>
          </div>
        </el-checkbox>
      </div>
    </div>
    <div v-for="item in info.goodsInfoList" :key="item.id" class="item-goods-item">
      <div class="item-goods-item-left">
        <el-checkbox
          v-model="item.checked"
          :true-label="1"
          :false-label="0"
          @change="(val) => chaneSelect(val, item.id)"
        ></el-checkbox>
        <el-image :src="item.converImage" class="cover-img"></el-image>
        <section>
          <div class="primary-text spu-name sl-ellipsis">{{ item.spuName }}</div>
          <div class="primary-text spu-en-name sl-ellipsis">{{ item.spuEnName }}</div>
        </section>
      </div>
      <div class="item-goods-item-price">
        <p>￥{{ item.price }}</p>
        <p class="prize-area"  :style="{ visibility: item.decrAmount > 0 ? '' : 'hidden', marginTop:'16px' }">
          商品优惠￥{{ item.decrAmount }}  Special offer {{ item.decrAmount }} 
        </p>
      </div>
      <div class="item-goods-item-right">
        <el-input-number
          size="small"
          v-model="item.qty"
          :min="1"
          :max="999"
          @change="(val) => changeCount(item.id, val)"
        ></el-input-number>
        <el-button class="del-btn" type="text" @click="handleDelete(item.id)">删除 Delete</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    takeType: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    handleSelect(val) {
      this.$emit("update:groupId", val);
    },
    //删除商品
    handleDelete(id) {
      this.$emit("handleDelete", id);
    },
    changeShopSelectAll(val, id) {
      let takeType = this.takeType;
      this.$emit("changeShopSelectAll", {
        checked: val,
        checkedValue: id,
        takeType,
      });
    },
    chaneSelect: function(val, id) {
      let takeType = this.takeType;
      this.$emit("chaneSelect", {
        checked: val,
        checkedValue: id,
        takeType,
      });
    },
    changeCount(id, val) {
      this.$emit("changeCount", {
        id,
        qty: val,
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.car-item {
  .take-type-title-content {
    background: #ffffff;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
    height: 40px;
    width: 1200px;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .item-goods-item {
    display: flex;
    align-items: flex-start;
    padding-left: 40px;
    padding-top: 30px;
    background: #fcfcfc;
    height: 148px;
    box-sizing: border-box;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
    &:last-child {
      border-bottom: 1px solid #f0f0f0;
    }
    .item-goods-item-left {
      display: flex;
      align-items: flex-start;
      .spu-name,
      .spu-en-name {
        width: 300px;
      }
      .cover-img {
        width: 88px;
        height: 88px;
        margin-left: 8px;
        margin-right: 20px;
      }
    }
    .item-goods-item-price {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
  }
  .item-goods-item-right {
    margin-left: auto;
    margin-right: 100px;
    .del-btn {
      margin-left: 20px;
      font-size: 14px;
      color: #333333;
    }
    /deep/ .el-input-number__decrease {
      background: #333333;
      color: #fff;
      border-radius: 0;
    }
    /deep/ .el-input-number__increase {
      background: #333333;
      color: #fff;
      border-radius: 0;
    }
  }
}
</style>
